import api from './api'

export const handleCepRequest = async( cep ) => {
  const result = await api.get( `/v2/endereco/consulta-cep/${cep}` )
  return result
}
